export default __webpack_public_path__ + "static/logo_full-6dbd9fd1107a88b877f02119b6d8cf16.png";